'use strict';

// Masses fixes telles que fournies par Philippe
// Intégration manuelle
// À terme, à remplacer par des données CSV EBP
//  idéalement par des données issues du configurateur 3D

export const CONST_MASSES = {

// Masses des options et refs générales

"ATG-G3/3": 0.977,
"ATG-G3/4": 1.302,
"ATG-G3/5": 1.628,
"ATG-G3/6": 1.953,
"ATG-G3/6.5": 2.279,
"ATG-G4/3": 1.277,
"ATG-G4/4": 1.702,
"ATG-G4/5": 2.128,
"ATG-G4/6": 2.553,
"ATG-G4/6.5": 2.979,
"ATG-G5/3": 1.577,
"ATG-G5/4": 2.102,
"ATG-G5/5": 2.628,
"ATG-G5/6": 3.153,
"TRANS-G3": 7.2,
"TRANS-G4": 9,
"TRANS-G5": 7.2,
"EMPORT-USINE": 0,
"LIVRAISON": 0,
"REM-QTE": 0,

"PACL": 0,//n'intervient pas dans le poids de l'abri

// Accessoires de finition de 2100 mm
"ANGLE_GD":3.15,
"BANDEAU_FAITAGE":3.5,
"FAITIERE_SOLIN":2.1,
"REJET_EAU":1.575,
"RIVE_GDE":2.52,
"RIVE_SOLIN":2.1,


// Commun G3 G4 G5 H3.3

"B3-LP_HAUT-3.3": 100.96,
"B4-LP_HAUT-3.3": 134.31,
"B5-LP_HAUT-3.3": 171.37,
"B6-LP_HAUT-3.3": 207.33,
"B6.5-LP_HAUT-3.3": 234.35,

"B3-LPH_RP-3.3": undefined,//Masse non communiquée
"B4-LPH_RP-3.3": undefined,//Masse non communiquée
"B5-LPH_RP-3.3": undefined,//Masse non communiquée
"B6-LPH_RP-3.3": undefined,//Masse non communiquée
"B6.5-LPH_RP-3.3": undefined,//Masse non communiquée


// G3 H3.3

"SP-G3-3.3/3": 274.57,
"SP-G3-3.3/4": 313.00,
"SP-G3-3.3/5": 351.43,
"SP-G3-3.3/6": 394.93,
"SP-G3-3.3/6.5": 423.90,

"B_PIGNON-G3-3.3": 114.69,
"B_PIG_RP-G3-3.3": 198.93,

"B3-LP_BAS-3.15": 97.92,
"B4-LP_BAS-3.15": 130.25,
"B5-LP_BAS-3.15": 166.29,
"B6-LP_BAS-3.15": 201.24,
"B6.5-LP_BAS-3.15": 227.24,

"B3-LPBAS_RP-3.15": undefined,//Masse non communiquée
"B4-LPBAS_RP-3.15": undefined,//Masse non communiquée
"B5-LPBAS_RP-3.15": undefined,//Masse non communiquée
"B6-LPBAS_RP-3.15": undefined,//Masse non communiquée
"B6.5-LPBAS_RP-3.15": undefined,//Masse non communiquée


// G4 H3.3

"SP-G4-3.3/3": 304.47,
"SP-G4-3.3/4": 348.89,
"SP-G4-3.3/5": 393.31,
"SP-G4-3.3/6": 442.80,
"SP-G4-3.3/6.5": 477.76,

"B_PIGNON-G4-3.3": 168.24,
"B_PIG_RP-G4-3.3": 225.56,

"B3-LP_BAS-3.1": 97.02,
"B4-LP_BAS-3.1": 129.05,
"B5-LP_BAS-3.1": 164.80,
"B6-LP_BAS-3.1": 199.44,
"B6.5-LP_BAS-3.1": 225.15,

"B3-LPBAS_RP-3.1": undefined,//Masse non communiquée
"B4-LPBAS_RP-3.1": undefined,//Masse non communiquée
"B5-LPBAS_RP-3.1": undefined,//Masse non communiquée
"B6-LPBAS_RP-3.1": undefined,//Masse non communiquée
"B6.5-LPBAS_RP-3.1": undefined,//Masse non communiquée


// G5 H3.3

"SP-G5-3.3/3": 355.90,
"SP-G5-3.3/4": 412.59,
"SP-G5-3.3/5": 464.31,
"SP-G5-3.3/6": 533.68,
"SP-G5-3.3/6.5": 579.08,

"B_PIGNON-G5-3.3": 200.50,
"B_PIG_RP-G5-3.3": 225.65,

"B3-LP_BAS-3.05": 96.12,
"B4-LP_BAS-3.05": 127.85,
"B5-LP_BAS-3.05": 163.30,
"B6-LP_BAS-3.05": 197.64,
"B6.5-LP_BAS-3.05": 223.05,

"B3-LPBAS_RP-3.05": undefined,//Masse non communiquée
"B4-LPBAS_RP-3.05": undefined,//Masse non communiquée
"B5-LPBAS_RP-3.05": undefined,//Masse non communiquée
"B6-LPBAS_RP-3.05": undefined,//Masse non communiquée
"B6.5-LPBAS_RP-3.05": undefined,//Masse non communiquée




// Commun G3 G4 G5 H2.55

"B3-LP_HAUT-2.55": 68.10,
"B4-LP_HAUT-2.55": 90.65,
"B5-LP_HAUT-2.55": 114.66,
"B6-LP_HAUT-2.55": 137.20,
"B6.5-LP_HAUT-2.55": 156.58,

"B3-LPH_RP-2.55": 100.94,
"B4-LPH_RP-2.55": 111.42,
"B5-LPH_RP-2.55": 146.03,
"B6-LPH_RP-2.55": 156.51,
"B6.5-LPH_RP-2.55": 187.95,


// G3 H2.55

"SP-G3-2.55/3": 252,
"SP-G3-2.55/4": 290.52,
"SP-G3-2.55/5": 328.86,
"SP-G3-2.55/6": 372.85,
"SP-G3-2.55/6.5": 401.82,

"B_PIGNON-G3-2.55": 83.82,
"B_PIG_RP-G3-2.55": 128.03,

"B3-LP_BAS-2.4": 65.06,
"B4-LP_BAS-2.4": 86.59,
"B5-LP_BAS-2.4": 109.58,
"B6-LP_BAS-2.4": 131.11,
"B6.5-LP_BAS-2.4": 149.47,

"B3-LPBAS_RP-2.4": 96.08,
"B4-LPBAS_RP-2.4": 105.54,
"B5-LPBAS_RP-2.4": 139.14,
"B6-LPBAS_RP-2.4": 148.60,
"B6.5-LPBAS_RP-2.4": 179.03,


// G4 H2.55

"SP-G4-2.55/3": 284.44,
"SP-G4-2.55/4": 328.95,
"SP-G4-2.55/5": 373.28,
"SP-G4-2.55/6": 425.80,
"SP-G4-2.55/6.5": 462.05,

"B_PIGNON-G4-2.55": 121.67,
"B_PIG_RP-G4-2.55": 140.65,

"B3-LP_BAS-2.35": 64.16,
"B4-LP_BAS-2.35": 85.39,
"B5-LP_BAS-2.35": 108.08,
"B6-LP_BAS-2.35": 129.31,
"B6.5-LP_BAS-2.35": 147.37,

"B3-LPBAS_RP-2.35": 94.56,
"B4-LPBAS_RP-2.35": 103.71,
"B5-LPBAS_RP-2.35": 137.02,
"B6-LPBAS_RP-2.35": 146.18,
"B6.5-LPBAS_RP-2.35": 176.31,


// G5 H2.55

"SP-G5-2.55/3": 333.34,
"SP-G5-2.55/4": 389.64,
"SP-G5-2.55/5": 446.74,
"SP-G5-2.55/6": 511.60,
"SP-G5-2.55/6.5": 557.00,

"B_PIGNON-G5-2.55": 143.17,
"B_PIG_RP-G5-2.55": 153.27,

"B3-LP_BAS-2.3": 63.26,
"B4-LP_BAS-2.3": 84.19,
"B5-LP_BAS-2.3": 106.59,
"B6-LP_BAS-2.3": 127.52,
"B6.5-LP_BAS-2.3": 145.28,

"B3-LPBAS_RP-2.3": 93.03,
"B4-LPBAS_RP-2.3": 101.89,
"B5-LPBAS_RP-2.3": 134.89,
"B6-LPBAS_RP-2.3": 143.75,
"B6.5-LPBAS_RP-2.3": 173.58,





// Anciennes refs disparues

// "SP-G3-2.35/3": 252.71,
// "SP-G3-2.35/4": 297.5,
// "SP-G3-2.35/5": 335.93,
// "SP-G3-2.35/6": 374.36,
// "SP-G3-2.35/6.5": 403.33,
// "SP-G4-2.35/3": 291.92,
// "SP-G4-2.35/4": 336.34,
// "SP-G4-2.35/5": 380.77,
// "SP-G4-2.35/6": 425.19,
// "SP-G5-2.35/3": 345.07,
// "SP-G5-2.35/4": 401.76,
// "SP-G5-2.35/5": 458.49,
// "SP-G5-2.35/6": 515.25,
//
// "B_PIGNON-G3-2.35": 76.14,
// "B_PIGNON-G4-2.35": 141.45,
// "B_PIGNON-G5-2.35": 119.83,
//
// "B3-LP_HAUT-2.35": 68.55,
// "B3-LPH_RP-2.35": 93.39,
// "B3-LP_BAS-2.15": 64.61,
// "B3-LP_BAS-2.2": 61.44,
// "B3-LP_BAS-2.1": 63.71,
//
// "B4-LP_HAUT-2.35": 91.32,
// "B4-LPH_RP-2.35": 102.7,
// "B4-LP_BAS-2.2": 81.77,
// "B4-LP_BAS-2.15": 88.28,
// "B4-LP_BAS-2.1": 84.86,
//
// "B5-LP_HAUT-2.35": 114.09,
// "B5-LPH_RP-2.35": 136.15,
// "B5-LP_BAS-2.2": 101.68,
// "B5-LP_BAS-2.15": 109.73,
// "B5-LP_BAS-2.1": 106.02,
//
// "B6-LP_HAUT-2.35": 136.76,
// "B6-LPH_RP-2.35": 145.46,
// "B6-LP_BAS-2.2": 122.44,
// "B6-LP_BAS-2.15": 131.09,
// "B6-LP_BAS-2.1": 127.07,
//
// "B6.5-LPH_RP-2.35": 175.73,
// "B6.5-LP_HAUT-2.35": 155.64,
// "B6.5-LP_BAS-2.2": 139.36,



// Refs EBP non utiles au site
"ANGLE_PT":false,
"BOULONS_12X30":false,
"BRACON":false,
"CONTRE_REMB":false,
"CACHE_PROFIL":false,
"ETUDE":false,
"FORFAIT.EMBAL":false,
"EMPORT":false,
"DIVERS":false,
"FAITIERE_PLATE":false,
"GOUJON_12X100":false,
"KIT-CABLE":false,
"LISSE-BARD_RP":false,
"LISSE_PIG":false,
"LINTEAU-CADRE_RP":false,
"LISSE-SOL_U":false,
"MOINS-VALUE_TOLE-B":false,
"MOINS-VALUE_TOLE-T":false,
"PANNE_PERIPH":false,
"PANNE_CTRE":false,
"PLATINE_MONO":false,
"PLATINE_SOL":false,
"POTEAU":false,
"POTEAU-CADRE_RP":false,
"PROFIL-C160":false,
"PROMO-10":false,
"PROMO-5":false,
"RIVE_PTE":false,
"T06":false,
"T06-INV":false,
"TAQUET_27-RP":false,
"TAQUET_28-RP":false,
"TAQUET_EQUERRE-12":false,
"TAQUET_PLATINE-18":false,
"TRANSLUCIDE":false,
"VIS_AUTO":false,
"VIS_COUTURAGE":false
};
